import script from "./Code.vue?vue&type=script&setup=true&lang=js"
export * from "./Code.vue?vue&type=script&setup=true&lang=js"

import "./Code.vue?vue&type=style&index=0&id=18dac0e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18dac0e4"]])

export default __exports__